import axios from 'axios';
import BaseApi from './base-api';

class LiabilitiesApi extends BaseApi {
  getLiabilities() {
    return axios
      .get(`${this.baseUrl}/liabilities`)
      .then((response) => {
        return {
          ok: true,
          liabilities: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const liabilitiesApi = new LiabilitiesApi();
